export const LOCAL_STORAGE_JWT_TOKEN = 'token';
export const LOCAL_STORAGE_CREDENTIALS = 'credentials';


export const DATE_TIME_FORMAT = 'dd MMMM yyyy HH:mm';
